import { render, staticRenderFns } from "./TunnelsTableEditForm.vue?vue&type=template&id=49a74486&scoped=true"
import script from "./TunnelsTableEditForm.vue?vue&type=script&lang=js"
export * from "./TunnelsTableEditForm.vue?vue&type=script&lang=js"
import style0 from "./TunnelsTableEditForm.vue?vue&type=style&index=0&id=49a74486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a74486",
  null
  
)

export default component.exports